import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaTrash } from "react-icons/fa";
import { webEndPoint } from "../constants/globalConstants";
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
export default function CartPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [cartData, setCartData] = useState([]);
  useEffect(() => {
    fetchCartData();
  }, []);
  const fetchCartData = async () => {
    setLoading(true);
    try {
      const url = webEndPoint + "cart/" + localStorage.getItem("userID");
      const response = await makeRequest("get", url);
      if (response) {
        setCartData(response?.data?.items || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const updateQty = async (cartItemId, qty) => {
    if (qty < 1) return;
    const payload = {
      cart_item_id: cartItemId,
      quantity: qty,
    };
    try {
      setLoading(true);
      const url = webEndPoint + "cart/update";
      const response = await makeRequest("put", url, payload);
      if (response) {
        await fetchCartData();
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update quantity");
    } finally {
      setLoading(false);
    }
  };
  const removeItem = async (cartItemId) => {
    setLoading(true);
    try {
      const url = webEndPoint + "cartItem/" + cartItemId;
      const response = await makeRequest("delete", url);
      if (response) {
        await fetchCartData();
        window.dispatchEvent(new Event("cartUpdated"));
        toast.success("Item removed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to remove item");
    } finally {
      setLoading(false);
    }
  };
  const subtotal = cartData?.reduce((acc, item) => acc + Number(item.price) * item.quantity, 0) || 0;
  const handleClick = () => {
    navigate("/user-checkout");
  };
  return (
    <div>
      <Loader loading={loading} />
      <Header />
      <div className="cart-container">
        <h2 style={{ width: "100%", textAlign: "center" }}>My Cart</h2>
        <button className="backhome-btn" onClick={() => navigate("/")}>Back to Home</button><br /><br />
        <div className="gradient-line"></div>
        {cartData?.length === 0 ? (
          <p className="empty-msg">Your cart is empty!</p>
        ) : (
          <>
            <div className="cart-grid">
              {cartData?.map((item) => (
                <div key={item.rfId} className="cart-card">
                  <img src={item.color_image_url} alt={item.product_name} />
                  <div className="cart-info">
                    <p className="product-name">{item.product_name}</p>
                    <p className="product-name">Color : {item.color_name}</p>
                    <p className="product-name">Variant : {item.size_name ? item.size_name : item.age_name}</p>
                    <p className="product-price">₹{item.price}</p>
                    <div className="option-group">
                      <h4>Quantity</h4>
                      <div className="quantity-box">
                        <button type="button" disabled={item.quantity <= 1} onClick={() => updateQty(item.cart_item_id, Math.max(1, item.quantity - 1))}>-</button>
                        <span>{item.quantity}</span>
                        <button type="button" onClick={() => updateQty(item.cart_item_id, item.quantity + 1)}>+</button>
                      </div>
                    </div>
                    <button className="remove-btn" onClick={() => removeItem(item.cart_item_id)}><FaTrash /> Remove</button>
                  </div>
                </div>
              ))}
            </div>
            <div className="cart-summary">
              <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
              <button className="checkout-btn" onClick={handleClick}>Proceed to Checkout</button>
            </div>
            <div>
              <h4>Note : Please don't press the back button until you get the order id If you have not received an order id Please WhatsApp 9360990836</h4>
              <h4>குறிப்பு : உங்களுக்கு ஆர்டர் ஐடி கிடைக்கும் வரை தயவுசெய்து Back பொத்தானை அழுத்த வேண்டாம். உங்களுக்கு ஆர்டர் ஐடி கிடைக்கவில்லை என்றால், தயவுசெய்து 9360990836 என்ற எண்ணுக்கு வாட்ஸ்அப் செய்யவும்.</h4>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}